/**
 * Single source of truth for Form Builder field types + standard info
 * block keys — mirrors backend/forms.py exactly. Shared by the Admin
 * builder and the member-facing renderer.
 */
export const FIELD_TYPES = [
  { value: "heading", label: "Section heading", layout: true },
  { value: "text_block", label: "Guidance / explanatory text", layout: true },
  { value: "short_text", label: "Short text" },
  { value: "long_text", label: "Long text area" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "time", label: "Time" },
  { value: "datetime", label: "Date & time" },
  { value: "checkbox", label: "Checkbox (yes/no)" },
  { value: "checkbox_group", label: "Multiple checkboxes", hasOptions: true },
  { value: "radio_group", label: "Single choice (radio buttons)", hasOptions: true },
  { value: "dropdown", label: "Dropdown selection", hasOptions: true },
  { value: "repeatable_group", label: "Repeatable rows / entries", hasSubFields: true },
];

export const SUB_FIELD_TYPES = FIELD_TYPES.filter(
  (t) => !t.layout && t.value !== "repeatable_group"
);

export const LAYOUT_TYPES = new Set(["heading", "text_block"]);
export const OPTION_TYPES = new Set(["checkbox_group", "radio_group", "dropdown"]);

export function fieldTypeLabel(value) {
  return (FIELD_TYPES.find((t) => t.value === value) || {}).label || value;
}

export const STANDARD_BLOCK_FIELDS = [
  { key: "carer_name", defaultLabel: "Carer name" },
  { key: "client_name", defaultLabel: "Client / person receiving care" },
  { key: "family_contact_name", defaultLabel: "Family / contact name" },
  { key: "form_date", defaultLabel: "Form date" },
  { key: "placement_reference", defaultLabel: "Placement / reference" },
  { key: "completion_datetime", defaultLabel: "Completion date/time" },
];

export function newFieldId() {
  return `f_${Math.random().toString(36).slice(2, 10)}_${Date.now().toString(36)}`;
}

export function blankField(type) {
  const def = FIELD_TYPES.find((t) => t.value === type);
  return {
    field_id: newFieldId(),
    type,
    label: def?.layout ? "" : "",
    help_text: "",
    placeholder: "",
    required: false,
    options: def?.hasOptions ? ["Option 1", "Option 2"] : undefined,
    sub_fields: def?.hasSubFields ? [blankField("short_text")] : undefined,
  };
}
